define([
    'uiComponent',
    '../model/gsap-helper',
    '../model/slide-activation-tracker'
], (Component, gsapHelper, slideActivation) => {
    'use strict';

    /**
     * @typedef {string} SlideIndex string index of slide
     */

    /**
     * @class
     * @typedef {Object} SlideComponent
     * @property {SlideIndex} index unique string identifier of slide
     */
    return Component.extend({
        defaults: {
            ScrollTrigger: gsapHelper.getScrollTrigger(),
            gsap: gsapHelper.getGsap(),
            isActive: false
        },

        /**
         * @param {Element} slideEl slide element
         */
        attachElement: function (slideEl) {
            this.ScrollTrigger.create(this.getScrollTriggerConfig(slideEl));
        },

        initObservable: function () {
            this._super();
            this.observe(['isActive']);
            return this;
        },

        /**
         * @param {Element} slideEl slide element
         * @returns {Object} extended config
         */
        getScrollTriggerConfig: function (slideEl) {
            return {
                trigger: slideEl,
                toggleClass: 'active',
                start: 'top bottom',
                end: 'bottom top',
                onToggle: self => {
                    const activationFn = self.isActive ? 'notifyActivation' : 'notifyDeactivation';
                    slideActivation[activationFn](this.index, self.direction);
                    this.isActive(self.isActive);
                },
                id: this.index
            };
        }
    });
});
